import client from '@/api/client.js'
import store from "@/store";
export default {
    methods: {
        async getFirmsList() {
            var meta = { clientApiMethod: 'getFirmsList', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Firm", { meta: meta })
            return response.data;
        },
    }
}